import DetailTable from './../DetailTable';

export default {
  name: 'DoctorDetail',
  data() {
    return {
      doctor: {},
      excludeFields: []
    }
  },
  components: {
    DetailTable
  },

  computed: {
    filteredDoctor() {
      let doctor = this.doctor;

      for (let field of this.excludeFields) {
        if (doctor.hasOwnProperty(field)) {
          delete doctor[field];
        }
      }

      return doctor;
    }
  },
  methods: {
    backToList() {
      this.$router.push({name: 'DoctorList'});
    }
  },
  created() {
    if (this.$route.params['doctor']) {
      this.doctor = this.$route.params['doctor'];
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/Doctor/js/detail.js